// Minimal settings context matching the cloudfront_ui useSettingsContext API
// used by blyn/layout.tsx for color scheme sync.

import { createContext, useContext, useState, useEffect } from 'react'
import type { ReactNode } from 'react'

interface SettingsCtx {
  colorScheme: 'light' | 'dark'
  onUpdateField: (field: string, value: unknown) => void
}

const SettingsContext = createContext<SettingsCtx>({
  colorScheme: 'dark',
  onUpdateField: () => {},
})

export function SettingsProvider({
  children,
  defaultColorScheme = 'dark',
}: {
  children: ReactNode
  defaultColorScheme?: 'light' | 'dark'
}) {
  const [settings, setSettings] = useState<Record<string, unknown>>({
    colorScheme: defaultColorScheme,
  })

  useEffect(() => {
    setSettings((prev) => ({ ...prev, colorScheme: defaultColorScheme }))
  }, [defaultColorScheme])

  const onUpdateField = (field: string, value: unknown) => {
    setSettings((prev) => ({ ...prev, [field]: value }))
  }

  return (
    <SettingsContext.Provider value={{ colorScheme: (settings.colorScheme as 'light' | 'dark') ?? defaultColorScheme, onUpdateField }}>
      {children}
    </SettingsContext.Provider>
  )
}

export function useSettingsContext() {
  return useContext(SettingsContext)
}
